// extracted by mini-css-extract-plugin
module.exports = {"root":"Vq3sS","line":"_3SrrN"};